import toast from "react-hot-toast";


// Toaster functions
export const notifySuccess = (msg) => toast.success(msg);

export const notifyError = (msg) => toast.error(msg);

// Email formatting function
export const getFormattedEmail = (email) => {
  const [name, domain] = email.split("@");
  let formattedEmail = "";
  for (let i = 0; i < name.length; i++) {
    if (i < 3) {
      formattedEmail += name[i];
    } else {
      formattedEmail += "*";
    }
  }
  return `${formattedEmail}@${domain}`;
};


// Auth token functions
export const saveAuthToken = (token) => {
  localStorage.setItem("access_token_AS", token);
};

export const deleteAuthToken = () => {
  localStorage.removeItem("access_token_AS");
};
